import type { Invoice } from '@dutchinvoice/types';
import {
    calculateLineItemTotal,
    calculateInvoiceTotals,
    calculateDueDate,
    generateNextInvoiceNumber,
    isSameCompany
} from '@dutchinvoice/shared-utils';

/**
 * IMPORTANT: This file re-exports centralized invoice calculation logic from shared-utils.
 * 
 * To maintain consistency across the application:
 * 1. ALWAYS use these functions for invoice calculations
 * 2. NEVER duplicate calculation logic in components
 * 3. For React components, prefer using the useInvoiceCalculations hook from 
 *    ../stores/selectors/invoiceSelectors.ts when working with the current invoice
 * 4. For calculations with saved/historical invoices, use these utility functions directly
 */

// Re-export shared utilities
export {
    calculateLineItemTotal,
    calculateInvoiceTotals,
    calculateDueDate,
    generateNextInvoiceNumber,
    isSameCompany
};

// Helper function to ensure invoice has required fields (frontend-specific)
export const ensureInvoiceId = (invoice: Invoice): Invoice & { synced: boolean } => {
    const newId = invoice.id || crypto.randomUUID();

    return {
        ...invoice,
        id: newId,
        synced: false
    };
}; 